import { render, staticRenderFns } from "./TheText.vue?vue&type=template&id=36457d03&"
import script from "./TheText.vue?vue&type=script&lang=js&"
export * from "./TheText.vue?vue&type=script&lang=js&"
import style0 from "./TheText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports